module.exports = __webpack_public_path__ + "static/media/logo.f3bcd118.svg";